export type LeadershipMember = {
  name: string;
  title: string;
  bio: string;
  location: string;
  img: string;
};

export const leadershipMembers: LeadershipMember[] = [
  {
    name: "J. David Washington",
    title: "Founder & Business Lead",
    bio: "Founder and business lead associated with 7 Hills Development Group, LLC, guiding the strategic vision behind Harambee Global Ventures.",
    location: "7 Hills Development Group, LLC",
    img: "/assets/images/site/placeholder-temp.svg",
  },
  {
    name: "Dr. Kelley Jibrell",
    title: "Advisory Team Member",
    bio: "Professor at Howard University in Washington, D.C., contributing academic perspective and strategic insight to Harambee's diaspora-centered platform.",
    location: "Washington, D.C.",
    img: "/assets/images/site/placeholder-temp.svg",
  },
  {
    name: "Dr. Daniel Moses",
    title: "Advisory Team Member",
    bio: "Real estate developer, lecturer, and author based in London, bringing cross-border business and market development experience to the advisory team.",
    location: "London, United Kingdom",
    img: "/assets/images/site/placeholder-temp.svg",
  },
  {
    name: "Ambassador Dr. Thomas Kwaka",
    title: "Advisory Team Member",
    bio: "Attorney and former U.S. Ambassador for Kenya, offering legal, diplomatic, and cross-border strategic perspective from Nairobi.",
    location: "Nairobi, Kenya",
    img: "/assets/images/site/placeholder-temp.svg",
  },
  {
    name: "Kenyatta Baraka",
    title: "Advisory Team Member",
    bio: "Chief Executive Officer of A2K Technology Group in Nairobi, contributing technology and operational perspective to the business plan advisory team.",
    location: "Nairobi, Kenya",
    img: "/assets/images/site/placeholder-temp.svg",
  },
  {
    name: "Emily Anderson, PE, P.Eng., PMP",
    title: "Advisory Team Member",
    bio: "Engineering and project management professional based in Houston, Texas, supporting execution, planning, and delivery discipline across the platform.",
    location: "Houston, Texas",
    img: "/assets/images/site/placeholder-temp.svg",
  },
  {
    name: "Dr. Charlie Kamotho",
    title: "Founder & CEO, Daktari Africa",
    bio: "Healthcare entrepreneur and physician leader, listed in the business plan advisory team as founder and CEO of Daktari Africa.",
    location: "Daktari Africa",
    img: "/assets/images/site/placeholder-temp.svg",
  },
];
